import pathOr from "ramda/src/pathOr";

export const pathOrString = pathOr("");
